import { Component } from "react";
import View from "./view";
import "./index.css";

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._close = this._close.bind(this);
  }

  render() {
    return View.call(this);
  }

  _close(event) {
    this.props.close();
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/dialog/index.js